<div
  class="fgbcl-game-answer-type-dropdown-container"
  [ngClass]="{ 'fgbcl-predictor': groupType == groupTypes.Predictor, 'fgbcl-trivia': groupType == groupTypes.Trivia }"
>
  <select
    (change)="onAnswerSelected()"
    [(ngModel)]="selectedAnswerId"
    class="form-select fgbcl-game-answer-type-dropdown"
    aria-label="Select option"
  >
    <option selected value="0">{{ 'fgbcl.game.answer.dropdown.select.player.option.text' | translate }}</option>
    <option *ngFor="let answer of answers" [ngValue]="answer.Id">{{ answer.Title }}</option>
  </select>
</div>
